const useSystemsStyles = () => {
    return {
        systemsContentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3
        },
        systemsGridCardStyles: {
            p: 1.5
        },
        addSystemButtonStyles: {
            width: 36,
            height: 36,
            borderRadius: 500,
            minWidth: 'unset'
        }
    };
};
export default useSystemsStyles;
